<template>
  <div class="cml-input-maxlength">
    <el-divider class="cml-divider" id="cml-divider" content-position="center"
      >{{ statusName }}单个包材样品</el-divider
    >
    <el-form
      :disabled="formDisabled"
      :model="formData"
      :rules="rules"
      ref="formData"
      label-width="300px"
    >
      <el-form-item label="供应商" prop="supplierCode">
        <el-input v-if="!['2', '1'].includes(this.$store.getters.userSelf.user.adminType) || status !== 'add'" disabled v-model.trim="formData.supplierName" />
        <SupplierSelect
          v-else
          :disabled="
            !['2', '1'].includes(this.$store.getters.userSelf.user.adminType) ||
            status !== 'add'
          "
          :value="formData.supplierCode"
          supplierType="PACKING_MATERIAL"
          @change-emit="supplierChange"
        />
      </el-form-item>
      <el-form-item id="img-box" label="包材形式" prop="form">
        <DictSelect
          type="cml_packingmaterial_form"
          :value="formData.form"
          @change-emit="formChange"
        />
      </el-form-item>
      <el-form-item label="产品名称" prop="productName">
        <el-input
          v-model.trim="formData.productName"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
        <span style="color: #AB0033; font-size: 12px; margin-left: 10px">
          {{ productNameTips[formData.form] }}
        </span>
      </el-form-item>
      <el-form-item
        label="配件名称"
        prop="accessoryCmds"
        required
        class="custom-tips"
      >
        <p
          v-for="(item, index) in formData.accessoryCmds"
          :key="index"
          class="input-group"
        >
          <el-input
            v-model.trim="item.name"
            :maxlength="maxlength"
            show-word-limit
          ></el-input>
          <el-button
            style="margin-left: 10px"
            icon="el-icon-plus"
            :disabled="!item.name"
            v-if="formData.accessoryCmds.length === index + 1"
            @click="addBtn('accessoryCmds', index)"
            size="mini"
          />
          <el-button
            style="margin-left: 10px"
            icon="el-icon-delete"
            v-show="formData.accessoryCmds.length > 1"
            @click="deleteBtn('accessoryCmds', index)"
            size="mini"
          />
        </p>
      </el-form-item>
      <el-form-item label="用途分类" prop="useClassificationCmds">
        <el-checkbox-group
          v-model="formData.useClassificationCmds"
          style="width: 480px"
        >
          <el-checkbox
            v-for="(item, index) in ytfls"
            :key="index"
            :label="item.value"
            name="type"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      
      <div v-if="formData.form && ['GLASS_BOTTLE', 'PLASTIC_BOTTLE', 'HOSE'].includes(formData.form)">
        <el-form-item
          label="包材容量单位"
          prop="capacityUnit"
        >
          <DictSelect
            type="cml_packingmaterial_capacityunit"
            :value="formData.capacityUnit"
            @change-emit="value => (formData.capacityUnit = value)"
          />
        </el-form-item>
        <el-form-item
          label="包材容量及价格"
          prop="capacityUnitPriceCmds"
          required
        >
          <div
            class="small-input input-group"
            v-for="(item, index) in formData.capacityUnitPriceCmds"
            :key="index"
          >
            <span>
              <CustomNumInput
                :value="item.capacity"
                :maxlength="7"
                :limitNum="0"
                @change-emit="val => (item.capacity = val)"
              />
              {{ formData.capacityUnit || 'ml' }}
            </span>
            <span>
              <CustomNumInput
                :value="item.price"
                :maxlength="7"
                :isNegativeFloat="true"
                @change-emit="val => (item.price = val)"
              />
              元/套
            </span>
            <el-button
              icon="el-icon-plus"
              :disabled="!item.capacity || !item.price"
              v-if="formData.capacityUnitPriceCmds.length === index + 1"
              @click="addCapacityUnitPrice('capacityUnitPriceCmds')"
              size="mini"
            />
            <el-button
              icon="el-icon-delete"
              v-show="formData.capacityUnitPriceCmds.length > 1"
              @click="deleteBtn('capacityUnitPriceCmds', index)"
              size="mini"
            />
          </div>
        </el-form-item>
      </div>
      <el-form-item v-if="formData.form && ['PRINT_COLOR_BOX', 'SOFT_PACKAGE', 'AUXILIARY_PRODUCTS'].includes(formData.form)" label="预估含税单价（元/个）" prop="price">
        <CustomNumInput
          :value="formData.price"
          :maxlength="7"
          :isNegativeFloat="true"
          @change-emit="val => (formData.price = val)"
        />
      </el-form-item>
      <el-form-item :label="`主图片${formData.form === 'AUXILIARY_PRODUCTS' ? '（附尺寸）' : ''}`" class="img-box" id="img-box2" required prop="mainImage">
        <span class="example-img" v-if="status !== 'detail'">
          <span>
            <b>图片示例</b><br />
          </span>
          <el-image 
            :src="exampleImgList[formData.form].imgs[0]" 
            :preview-src-list="[exampleImgList[formData.form].imgs[0]]"
          >
          </el-image>
        </span>
        <UploadImage
          v-if="showUploadImage"
          ref="uploadImage"
          :disabled="formDisabled"
          tipsText="上传主图片"
          :imgUrl="formData.mainImage"
          @img-change="mainImageChange"
        />
      </el-form-item>
      <el-form-item
        label="是否新材质或者新工艺"
        v-if="formData.form === 'SOFT_PACKAGE'"
        required
        prop="newConstruction"
        :rules="[
          { required: true, message: '请选择是否新材质或者新工艺', trigger: 'change' },
        ]"
      >
        <el-radio-group v-model="formData.newConstruction" @change="constructionChange">
          <el-radio label="YES">是</el-radio>
          <el-radio label="NO">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 附件2 -->
      <el-form-item
        :label="exampleImgList[formData.form].label_1"
        :required="exampleImgList[formData.form].label_1_required"
        class="img-box"
        prop="sideImageList"
        v-if="formData.form !== 'AUXILIARY_PRODUCTS' && (!formData.newConstruction || formData.newConstruction === 'YES')"
      >
        <span class="example-img" v-if="status !== 'detail'">
          <span>
            <b>图片示例</b><br />
            <span>{{exampleImgList[formData.form].label_1_img_title || ''}}</span>
          </span>
          <el-image 
            :src="exampleImgList[formData.form].imgs[1]"
            :preview-src-list="[exampleImgList[formData.form].imgs[1]]"
          >
          </el-image>
        </span>
        <UploadImageList
          ref="sideImageRef"
          tipsText="上传图片"
          :disabled="formDisabled"
          @img-change="sideImageListChange"
        />
      </el-form-item>
      <el-form-item
        label="是否新结构"
        v-if="formData.form === 'SOFT_PACKAGE'"
        required
        prop="newTechnology"
        :rules="[
          { required: true, message: '请选择是否新结构', trigger: 'change'},
        ]">
        <el-radio-group v-model="formData.newTechnology" @change="technologyChange">
          <el-radio label="YES">是</el-radio>
          <el-radio label="NO">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 附件3 -->
      <el-form-item
        :label="exampleImgList[formData.form].label_2"
        :required="exampleImgList[formData.form].label_2_required"
        class="img-box"
        prop="structureImageList"
        v-if="formData.form !== 'AUXILIARY_PRODUCTS' && (!formData.newTechnology || formData.newTechnology === 'YES')"
      >
        <span class="example-img" v-if="status !== 'detail'">
          <span>
            <b>图片示例</b>
            <br />
            <span>{{exampleImgList[formData.form].label_2_img_title || ''}}</span>
          </span>
          <el-image 
            :src="exampleImgList[formData.form].imgs[2]" 
            :preview-src-list="[exampleImgList[formData.form].imgs[2]]"  
          >
          </el-image>
        </span>
        <UploadImageList
          id="img-box3"
          ref="structureImageRef"
          tipsText="上传图片"
          :disabled="formDisabled"
          @img-change="structureImageListChange"
        />
      </el-form-item>
      <el-form-item label="材质" prop="material">
        <el-input
          v-model.trim="formData.material"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="是否有专利" prop="havePatent">
        <DictSelect
          type="cml_common_whether"
          :value="formData.havePatent"
          @change-emit="value => (formData.havePatent = value)"
        />
      </el-form-item>
      <el-form-item label="生产周期（天）" prop="productionCycle">
        <CustomNumInput
          :value="formData.productionCycle"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.productionCycle = val)"
        />
      </el-form-item>
      <el-form-item label="正式订单的最低起订量（个）" prop="minNum">
        <CustomNumInput
          :value="formData.minNum"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.minNum = val)"
        />
      </el-form-item>
      <el-form-item label="是否做过大货生产" prop="haveMassProduction">
        <DictSelect
          type="cml_common_whether"
          :value="formData.haveMassProduction"
          @change-emit="haveMassProductionChange"
        />
      </el-form-item>
      <el-form-item v-if="formData.haveMassProduction === 'YES'" label="已使用品牌" prop="brandsUsed">
        <el-input
          v-model.trim="formData.brandsUsed"
          :maxlength="maxlength"
          show-word-limit
          placeholder="多个品牌请用逗号隔开"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="formData.haveMassProduction === 'NO'"
        label="开发进度"
        prop="developmentProgress"
      >
        <el-input
          v-model.trim="formData.developmentProgress"
          :maxlength="maxlength"
          show-word-limit
          placeholder="请说明开发进度"
        ></el-input>
      </el-form-item>
      <el-form-item label="样品的发货时间" prop="deliveryTime">
        <CustomNumInput
          :value="formData.deliveryTime"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.deliveryTime = val)"
        />
        天内
      </el-form-item>
      <el-form-item label="是否被水羊启用过" prop="shuiyangEnable">
        <DictSelect
          type="cml_common_whether"
          :value="formData.shuiyangEnable"
          @change-emit="value => (formData.shuiyangEnable = value)"
        />
      </el-form-item>
      <el-form-item id="editor-box" label="产品详情" prop="information">
        <TextareaEditor :disabled="formDisabled" ref="textareaEditor" />
      </el-form-item>
    </el-form>
    <span
      v-if="!formDisabled && status !== 'verify'"
      style="margin: 20px 0 50px 300px"
    >
      <el-button size="medium" :loading="saveLoading" @click="saveBtn"
        >保存草稿</el-button
      >
      <el-button
        type="primary"
        size="medium"
        style="margin-left: 50px"
        :loading="saveLoading"
        @click="submitBtn"
        >提交审核</el-button
      >
    </span>

    <SubmitDialog
      :dialogVisible="dialogVisible"
      @create-again="createAgain"
      @to-sample-page="toSamplePage"
    />

    <!-- 审核 -->
    <VerifyComponent
      ref="verifyComponent"
      :status="status"
      :statusName="statusName"
      :saveLoading="saveLoading"
      @verify-btn="verifyBtn"
    />
  </div>
</template>
<script>
import SupplierSelect from '@/components/SupplierSelect';
import DictSelect from '@/components/DictSelect';
import UploadImage from '@/components/Upload/UploadImage.vue';
import UploadImageList from '@/components/Upload/UploadImageList.vue';
import CustomNumInput from '@/components/CustomNumInput';
import TextareaEditor from '@/components/TextareaEditor';
import VerifyComponent from '../sample-component/VerifyComponent.vue';
import SubmitDialog from '../sample-component/SubmitDialog.vue';

// import { pageStatus } from '@/utils/pageInfo';
import { uniqBy, cloneDeep } from 'lodash';
import sampleCreate from '@/mixins/sampleCreate';

export default {
  name: 'publish-package-sample',
  components: {
    SupplierSelect,
    DictSelect,
    UploadImage,
    UploadImageList,
    CustomNumInput,
    TextareaEditor,
    VerifyComponent,
    SubmitDialog,
  },
  mixins: [sampleCreate],
  data() {
    const accessoryCmdsValid = (rule, value, callback) => {
      if (value.some(item => !item.name)) {
        this.pageScrollToTop();
        callback(new Error('请输入配件名称'));
      } else {
        callback();
      }
    };
    const capacityUnitPriceCmdsValid = (rule, value, callback) => {
      if (value.some(item => !item.capacity || !item.price)) {
        this.pageScrollToTop();
        callback(new Error('请输入包材容量、预估含税单价'));
      } else {
        callback();
      }
    };
    const mainImageValid = (rule, value, callback) => {
      if (!value || value.length < 1) {
        this.pageScrollToTop();
        callback(new Error('请选择图片'));
      } else {
        callback();
      }
    };
    const sideImageValid = (rule, value, callback) => {
      if (this.exampleImgList[this.formData.form].label_1_required) {
        if (!value || value.length < 1) {
          this.pageScrollToTop();
          callback(new Error('请选择图片'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const structureImageValid = (rule, value, callback) => {
      if (this.exampleImgList[this.formData.form].label_2_required) {
        if (!value || value.length < 1) {
          this.pageScrollToTop('img-box3');
          callback(new Error('请选择图片'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      id: '',
      row: { id: '' },
      formData: {
        newConstruction: 'YES',
        newTechnology: 'YES',
        sampleId: '',
        id: '',
        supplierCode: '',
        supplierName: '',
        productName: '',
        accessoryCmds: [{ name: '', packingMaterialId: '' }],
        useClassificationCmds: [],
        form: 'GLASS_BOTTLE',
        price: '',
        capacityUnit: '',
        capacityUnitPriceCmds: [
          { capacity: '', price: '', packingMaterialId: '' },
        ],
        mainImage: '',
        sideImageList: [],
        structureImageList: [],
        material: '',
        havePatent: '',
        productionCycle: '',
        minNum: '',
        haveMassProduction: '',
        developmentProgress: '',
        brandsUsed: '',
        deliveryTime: '',
        shuiyangEnable: '',
        information: '',
      },
      ytfls: [],
      rules: {
        supplierCode: [
          { required: true, message: '请选择供应商', trigger: 'change' },
        ],
        accessoryCmds: [{ validator: accessoryCmdsValid, trigger: 'blur' }],
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
        ],
        useClassificationCmds: [
          { required: true, message: '请选择用途分类', trigger: 'change' },
        ],
        form: [
          { required: true, message: '请选择包材形式', trigger: 'change' },
        ],
        capacityUnitPriceCmds: [
          { validator: capacityUnitPriceCmdsValid, trigger: 'blur' },
        ],
        price: [
          { required: true, message: '请输入预估含税单价', trigger: 'blur' },
        ],
        capacityUnit: [
          { required: true, message: '请选择包材容量单位', trigger: 'change' },
        ],
        mainImage: [{ validator: mainImageValid, trigger: 'blur' }],
        sideImageList: [{ validator: sideImageValid, trigger: 'blur' }],
        structureImageList: [{ validator: structureImageValid, trigger: 'blur' }],
        material: [{ required: true, message: '请输入材质', trigger: 'blur' }],
        havePatent: [
          { required: true, message: '请选择是否有专利', trigger: 'change' },
        ],
        productionCycle: [
          { required: true, message: '请输入生产周期', trigger: 'blur' },
        ],
        minNum: [
          {
            required: true,
            message: '请输入正式订单的最低起订量 （个）',
            trigger: 'blur',
          },
        ],
        haveMassProduction: [
          {
            required: true,
            message: '请选择是否做过大货生产',
            trigger: 'change',
          },
        ],
        deliveryTime: [
          { required: true, message: '请输入样品的发货时间', trigger: 'blur' },
        ],
        shuiyangEnable: [
          {
            required: true,
            message: '请选择是否被水羊启用过',
            trigger: 'change',
          },
        ],
      },
      saveLoading: false,
      status: 'add',
      statusName: '新增',
      maxlength: 30,
      formDisabled: false,
      dialogVisible: false,
      useClassificationCmds: [],
      showUploadImage: true,
      exampleImgList: {
        // 玻璃瓶
        GLASS_BOTTLE: {
          imgs:[
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai1.png',
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai2.png',
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai3.png'
          ],
          label_1: '细节图片（瓶口/泵头/盖子）',
          label_2: '尺寸图片',
          label_1_required: true,
          label_2_required: true
        },
        //塑料瓶
        PLASTIC_BOTTLE: {
          imgs:[
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai1.png',
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai2.png',
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai3.png'
          ],
          label_1: '细节图片（瓶口/泵头/盖子）',
          label_2: '尺寸图片',
          label_1_required: true,
          label_2_required: true
        },
        // 软管
        HOSE: {
          imgs:[
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai1.png',
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai2.png',
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai3.png'
          ],
          label_1: '细节图片（瓶口/泵头/盖子）',
          label_2: '尺寸图片',
          label_1_required: true,
          label_2_required: true
        },
        // 印刷类彩盒
        PRINT_COLOR_BOX: {
          imgs: [
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai_print1.png',
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai_print2.png',
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai_print3.png'
          ],
          label_1: '侧面图片',
          label_2: '结构图片',
          label_1_required: false,
          label_2_required: false
        },
        // 软包
        SOFT_PACKAGE: {
          imgs: [
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai_ruanbao1.png',
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai_ruanbao2.png',
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai_ruanbao3.png'
          ],
          label_1: '细节图片（材质等）',
          label_2: '结构图片',
          label_1_required: false,
          label_2_required: false,
          label_1_img_title: '新工艺激凸',
          label_2_img_title: '新结构双腔'
        },
        // 辅消品
        AUXILIARY_PRODUCTS: {
          imgs: [
            'https://oss.syounggroup.com/static/file/cml-main-service/example/baocai_fuxiao1.png'
          ]
        }
      },
      productNameTips: {
        GLASS_BOTTLE: '品类（水乳膏霜）-规格（g/ml）-公模/私模-玻璃瓶-样品名称',
        PLASTIC_BOTTLE: '材质＋容量+形状+功能（面霜&水&乳）',
        HOSE: '管径+盖型+管型+材质（几层塑管、铝塑管、纯铝管）+特殊点（如有，例如软管头）',
        PRINT_COLOR_BOX: '结构特点+礼盒、彩盒'
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.checkQueryParams(vm);
    });
  },
  mounted() {
    const { code, name } = this.$store.getters.userSupplier;
    const {
      cml_packingmaterial_useclassification,
    } = this.$store.getters.allDictListData.data;
    if(code) {
      this.formData.supplierCode = code;
      this.formData.supplierName = name;
    }
    this.ytfls = cml_packingmaterial_useclassification;
  },
  methods: {
    technologyChange (val) {
      if (!val) return;
      if (val === 'YES') {
        this.exampleImgList[this.formData.form].label_2_required = true;
      } else {
        this.formData.structureImageList = [];
        this.exampleImgList[this.formData.form].label_2_required = false;
      }
    },
    constructionChange (val) {
      if (!val) return;
      if (val === 'YES') {
        this.exampleImgList[this.formData.form].label_1_required = true;
      } else {
        this.formData.sideImageList = [];
        this.exampleImgList[this.formData.form].label_1_required = false;
      }
    },
    getDetail() {
      this.$http.sampleManage
        .getPackingMaterialSample(this.id)
        .then(result => {
          for (let i in this.formData) {
            this.formData[i] = result.data[i];
          }
          this.formData.sampleId = this.row.id;
          this.formData.accessoryCmds = result.data.accessoryVOList;
          this.formData.useClassificationCmds = result.data.useClassificationVOList.map(
            item => item.classification,
          );
          this.useClassificationCmds = result.data.useClassificationVOList;
          this.formData.capacityUnitPriceCmds = result.data.capacityUnitPriceVOList;
          // 选择印刷类/其他，预估单价值需要转换
          if(['PRINT_COLOR_BOX', 'SOFT_PACKAGE', 'AUXILIARY_PRODUCTS'].includes(result.data.form)) {
            this.formData.price = result.data.capacityUnitPriceVOList[0].price;
          }
          this.constructionChange(this.formData.newConstruction);
          this.technologyChange(this.formData.newTechnology);
          // 设置默认列表
          this.$nextTick(()=> {
            if (this.formData.form !== 'AUXILIARY_PRODUCTS') {
              if (!this.formData.newConstruction || this.formData.newConstruction === 'YES') {
                this.$refs.sideImageRef.setFileListData(this.formData.sideImageList)
              }
              if (!this.formData.newTechnology || this.formData.newTechnology === 'YES') {
                this.$refs.structureImageRef.setFileListData(this.formData.structureImageList)
              }
            }
          })
          // 设置textarea内容
          this.$refs.textareaEditor.setHtml(result.data.information);
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    addBtn(val) {
      this.formData[val].push({ name: '' });
    },
    addCapacityUnitPrice(val) {
      this.formData[val].push({ capacity: '', price: '' });
    },
    deleteBtn(val, index) {
      this.formData[val].splice(index, 1);
    },
    checkParams() {
      let state = true;
      if(this.formData.accessoryCmds.some(item => !item.name)) {
        this.pageScrollToTop();
        this.$message.error('配件名称不能为空，请重新填写');
        state = false;
        return;
      }
      if(
        uniqBy(this.formData.accessoryCmds, 'name').length !==
        this.formData.accessoryCmds.length
      ) {
        this.pageScrollToTop();
        this.$message.error('配件名称重复，请重新填写');
        state = false;
        return;
      }
      if(
        ['GLASS_BOTTLE', 'PLASTIC_BOTTLE', 'HOSE'].includes(this.formData.form) &&
        this.formData.capacityUnitPriceCmds.some(
          item => !item.capacity || !item.price,
        )
      ) {
        this.pageScrollToTop();
        this.$message.error('包材容量及价格不能为空，请重新填写');
        state = false;
        return;
      }
      if(['GLASS_BOTTLE', 'PLASTIC_BOTTLE', 'HOSE'].includes(this.formData.form)) {
        const capacityUnitPriceCmdsData = this.formData.capacityUnitPriceCmds;
        const arr = capacityUnitPriceCmdsData.reduce((prev, cur) => {
          if(prev.length < 1) {
            prev.push(cur);
          } else if (
            !prev.some(
              item =>
                item.capacity === cur.capacity && item.price === cur.price,
            )
          ) {
            prev.push(cur);
          }
          return prev;
        }, []);
        if(arr.length !== capacityUnitPriceCmdsData.length) {
          this.pageScrollToTop();
          this.$message.error('包材容量及价格重复，请重新填写');
          state = false;
          return;
        }
      }
      if(!this.formData.mainImage) {
        this.$message.error('请选择主图片');
        state = false;
        return;
      }
      // if(this.formData.sideImageList.length < 1) {
      //   this.$message.error('请选择侧面图片');
      //   state = false;
      //   return;
      // }
      // if(this.formData.structureImageList.length < 1) {
      //   this.$message.error('请选择结构图片');
      //   state = false;
      //   return;
      // }
      if(this.formData.productionCycle === '0') {
        this.$message.error('生产周期必须大于0');
        state = false;
        return;
      }
      if(this.formData.deliveryTime === '0') {
        this.$message.error('样品的发货时间必须大于0');
        state = false;
        return;
      }
      if(this.formData.minNum === '0') {
        this.$message.error('正式订单的最低起订量必须大于0');
        state = false;
        return;
      }
      const { imgUrls, text } = this.$refs.textareaEditor.getHtml();
      if(imgUrls.length > 20) {
        this.$message.error('产品详情最多可以上传20张图片');
        state = false;
        return;
      }
      if(text.length > 5000) {
        this.$message.error('产品详情最多可以输入5000个字符');
        state = false;
        return;
      }
      return state;
    },
    saveBtn(val) {
      this.$refs.formData.validate(async valid => {
        if(valid) {
          if(this.checkParams()) {
            const { allHtml } = this.$refs.textareaEditor.getHtml();
            let params = cloneDeep(this.formData);
            params.information = allHtml.trim();
            // 配件名称
            params.accessoryCmds = params.accessoryCmds.map(item => {
              return {
                name: item.name,
                packingMaterialId: params.id || '',
              };
            });
            // 用途分类
            params.useClassificationCmds = params.useClassificationCmds.map(
              item => {
                return {
                  classification: item,
                  packingMaterialId: params.id || '',
                };
              },
            );
            // 包材容量及价格
            if(['GLASS_BOTTLE', 'PLASTIC_BOTTLE', 'HOSE'].includes(this.formData.form)) {
              params.capacityUnitPriceCmds = params.capacityUnitPriceCmds.map(
                item => {
                  return {
                    capacity: item.capacity,
                    price: item.price,
                    packingMaterialId: params.id || '',
                  };
                },
              );
            } else {
              // 选择印刷类/其他
              params.capacityUnitPriceCmds = [
                {
                  capacity: '',
                  price: this.formData.price,
                  packingMaterialId: params.id || '',
                },
              ];
            }

            const $url = ['add', 'copy'].includes(this.status) ? 'createPackingMaterialSample' : 'updatePackingMaterialSample';
            if(['add', 'copy'].includes(this.status)) {
              delete params.id;
              delete params.sampleId;
            }

            try {
              const msg = await this.saveParams($url, params);
              // 提交
              if(val === 'submit') {
                this.$http.sampleManage
                  .batchSubmitSample([this.row.id])
                  .then(result => {
                    if(result.data.failNum > 0) {
                      this.$message.error(
                        result.data.failResultList[0].code +
                          result.data.failResultList[0].msg,
                      );
                    } else {
                      this.dialogVisible = true;
                    }
                  })
                  .catch(err => {
                    this.$message.error(err.msg);
                  })
                  .finally(() => {
                    this.saveLoading = false;
                  });
              } else {
                if(['add', 'copy', 'update'].includes(this.status)) {
                  this.$message.success(msg);
                  this.toSamplePage('submitSuccessToHistoryTab1');
                } else if (this.status === 'verify') {
                  // 审核
                  const params = {
                    ...this.$refs.verifyComponent.verifyFormData,
                  };
                  params.sampleId = this.row.id;
                  this.saveLoading = true;
                  this.$http.sampleManage
                    .createSampleCheck(params)
                    .then(result => {
                      this.$message.success(result.msg);
                      this.toSamplePage(
                        'toListTab1',
                        'sample-manage/verify-sample',
                        '审核样品',
                      );
                    })
                    .catch(err => {
                      this.$message.error(err.msg);
                    })
                    .finally(() => {
                      this.saveLoading = false;
                    });
                }
              }
            } catch (err) {
              this.$message.error(err);
            }
          }
        } else {
          this.$message.error('必填项不能为空，请认真检查哦！');
          // this.pageScrollToTop();
          return false;
        }
      });
    },
    saveParams($url, params) {
      return new Promise((reslove, reject) => {
        this.saveLoading = true;
        this.$http.sampleManage[$url](params)
          .then(result => {
            // code=-1，错误提示
            if(result.data.code && result.data.code == -1) {
              reject(result.data.msg);
              return;
            }
            if(['add', 'copy'].includes(this.status)) {
              this.row.id = result.data;
            }
            reslove(result.msg);
          })
          .catch(err => {
            reject(err.msg);
          })
          .finally(() => {
            this.saveLoading = false;
          });
      });
    },
    resetForm() {
      this.showUploadImage = false;
      this.$nextTick(() => {
        this.showUploadImage = true;
      });
      this.status = 'add';
      this.statusName = '新增';
      this.row = { id: '' };
      this.$refs.formData.resetFields();
      this.formData.mainImage = '';
      this.formData.sideImageList = [];
      this.formData.structureImageList = [];
      this.formData.accessoryCmds = [{ name: '', packingMaterialId: '' }];
      this.formData.capacityUnitPriceCmds = [
        { capacity: '', price: '', packingMaterialId: '' },
      ];
      this.formData.form = 'GLASS_BOTTLE';
      this.formData.material = '';
      this.formData.productionCycle = '';
      this.formData.haveMassProduction = '';
      this.formData.minNum = '';
      this.formData.deliveryTime = '';
      this.formData.useClassificationCmds = [];
      this.$refs.textareaEditor.clear();
      const { code, name } = this.$store.getters.userSupplier;
      this.formData.supplierCode = code;
      this.formData.supplierName = name;
    },
    mainImageChange(val) {
      this.formData.mainImage = val;
      if(val) {
        this.$refs.formData.clearValidate('mainImage');
      } else {
        this.$refs.formData.validateField('mainImage');
      }
    },
    sideImageListChange(val) {
      this.formData.sideImageList = val;
      if(val.length > 0) {
        this.$refs.formData.clearValidate('sideImageList');
      } else {
        this.$refs.formData.validateField('sideImageList');
      }
    },
    structureImageListChange(val) {
      this.formData.structureImageList = val;
      if(val.length > 0) {
        this.$refs.formData.clearValidate('structureImageList');
      } else {
        this.$refs.formData.validateField('structureImageList');
      }
    },
    supplierChange(val, name) {
      this.formData.supplierCode = val;
      this.formData.supplierName = name;
    },
    formChange(val) {
      this.formData.form = val;
      this.formData.capacityUnit = '';
      this.formData.price = '';
      this.formData.mainImage = '';
      this.formData.sideImageList = [];
      this.formData.structureImageList = [];
      this.formData.capacityUnitPriceCmds = [
        { capacity: '', price: '', packingMaterialId: '' },
      ];
      this.$nextTick(() => {
        if (val !== 'AUXILIARY_PRODUCTS') {
          this.$refs.sideImageRef.setFileListData([]);
          this.$refs.structureImageRef.setFileListData([]);
        }
      })
      this.$refs.formData.clearValidate();
      if (val === 'SOFT_PACKAGE') {
        this.formData.newConstruction = 'YES';
        this.formData.newTechnology = 'YES';
        this.constructionChange(this.formData.newConstruction);
        this.technologyChange(this.formData.newTechnology);
      } else {
        this.formData.newConstruction = '';
        this.formData.newTechnology = '';
      }
    },
    haveMassProductionChange(val) {
      this.formData.haveMassProduction = val;
      this.formData.brandsUsed = '';
      this.formData.developmentProgress = '';
    },
  },
};
</script>
